import React from 'react'

export default function HIGHLOWFaqs({getDetails,fiveExtData}) {
    return (
        <><h3>FAQs</h3>
            <div className='today-faqs'>

                <h3>What is 52 week high?</h3>

                <p>As the name suggests 52 week high, is the highest price that the security/stock has traded over a 52 week period i.e. a year. Typically, the 52-week high represents a resistance level.</p>

                <h3>What is 52 week low?</h3>

                <p>As the name suggests 52 week low, is the lowest price that the security/stock has traded over a 52 week period i.e. a year. Typically the 52-week low is a support level that traders can use to trigger trading decisions.</p>

                <h3>How to trade 52 week high stocks?</h3>

                <p>The 52-week high strategy is a method of investing that seeks to buy stocks that are trading close to their 52-week highs. As 52 week high stocks outperform the ones that are trading far away from their 52-week highs. The strategy goes against the intuitive “buy low and sell high” mantra. As 52 week high is resistance level, when it breaks after many days, weeks or months, it is called breakout. So at this level, you may buy stocks. Also check volume of stocks & chart pattern for sureshot.</p>

                <h3>How to trade 52 week low stocks?</h3>

                <p>Buying stocks which are making 52 week low is not good trading strategy. A 52 week low levels are support level. If 52 week low is broken, you don’t know where that stocks will stop falling. So never buy immediately stocks which are making 52 week low. For buying such stocks, you must wait 1-2 months to get stabilized and start bouncing from that levels with good volumes.</p>

                <h3>Is it good to buy 52 week low shares?</h3>

                <p>No, unless untill it starts bouncing from that levels with good volume and gets stabilized.</p>

                <h3>Is it good to buy 52 week high share?</h3>

                <p>Yes, if 52 week high share broken recently good chart pattern with good volume.</p>

                <h3>Is it good to buy stocks near 52 week high?</h3>

                <p>Yes, it is good to buy stocks near 52 week high. There is very high probability that stocks which are very close to 52 week high, will make it again new 52 week high.</p>

                <h3>Is it good to buy stocks near 52 week low?</h3>

                <p>No, it is not good to buy stocks near 52 week low. There is very high probability that stocks which are very close to 52 week low, will make it again new 52 week low.</p>

                <h3>When to buy 52 week high stocks?</h3>

                <p>When 52 week high stocks retraces from 52 week high and are within 5-12% from high, it may be bought in anticipation that it may again make new high.</p>

                <h3>When to buy 52 week low stocks?</h3>

                <p>When 52 week low shares retraces from 52 week low and are above 15-20% from 52 week low, you may start buying in staggered way.</p>

                <h3>What are stocks with 52 week high today?</h3>

                <p>Today list of 52 week high stocks are as below.</p>

                <table className='table table-bordered'>
                    <thead>
                        <th>Symbol</th>
                        <th style={{'textAlign':'center'}}>LTP</th>
                        <th style={{'textAlign':'center'}}>New 52W/H price</th>
                        <th style={{'textAlign':'center'}}>Prev. High</th>
                        <th style={{'textAlign':'center'}}>Change</th>
                        <th style={{'textAlign':'center'}}>%CHG</th>
                    </thead>
                    <tbody>
                        {getDetails?.slice(0, 5).map((value, key) => (
                            <tr key={`tabkey${key}`}>
                                <td>{value.symbol}</td>
                                <td style={{ color: "green" ,'textAlign':'center'}}>{value.ltp}</td>
                                <td style={{'textAlign':'center'}}>{value.currprice}</td>
                                <td style={{'textAlign':'center'}}>{value.preHigh}</td>
                                <td style={{ color: value.chg > 0 ? "green" : "red" ,'textAlign':'center'}}>{value.chg}</td>
                                <td style={{ color: value.cp > 0 ? "green" : "red" ,'textAlign':'center'}}>{value.cp}</td>
                            </tr>
                        ))}

                    </tbody>
                </table>

                <h3>What are stocks with 52 week low today?</h3>

                <p>Today list of 52 week low shares are as below.</p>

                <table className='table table-bordered'>
                    <thead>
                        <th>Symbol</th>
                        <th style={{'textAlign':'center'}}>LTP</th>
                        <th style={{'textAlign':'center'}}>New 52W/H price</th>
                        <th style={{'textAlign':'center'}}>Prev. High</th>
                        <th style={{'textAlign':'center'}}>Change</th>
                        <th style={{'textAlign':'center'}}>%CHG</th>
                    </thead>
                    <tbody>
                        {fiveExtData?.slice(0, 5).map((value, key) => (
                            <tr key={`tabkey${key}`}>
                                <td>{value.symbol}</td>
                                <td style={{ color: "green" ,'textAlign':'center'}}>{value.ltp}</td>
                                <td style={{'textAlign':'center'}}>{value.currprice}</td>
                                <td style={{'textAlign':'center'}}>{value.preHigh}</td>
                                <td style={{ color: value.chg > 0 ? "green" : "red" ,'textAlign':'center'}}>{value.chg}</td>
                                <td style={{ color: value.cp > 0 ? "green" : "red" ,'textAlign':'center'}}>{value.cp}</td>
                            </tr>
                        ))}

                    </tbody>
                </table>

                <h3>Why is market going down?</h3>

                <p>A stock market collapse typically occurs when the economy is overheated, inflation is rising, market speculation is rampant, and there is significant uncertainty about the path of an economy.</p>

                <h3>Why has market suddenly crashed?</h3>

                <p>The sudden drop in stock prices may be influenced by economic conditions, catastrophic event(s), or speculative elements that sweep across the market. Most market crashes are usually short bursts of market downturns that can last for a single day or much longer to bring investors heavy losses.</p>


            </div>
        </>
    )
}
